import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import * as ProyectoService from 'services/proyecto.service'

const fetcher = () => ProyectoService.obtenerAsSelect().then(({ data }) => data)

const ProyectoSelect = props => {
  const { data: proyectos } = useSwr('select_proyectos', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {proyectos.map((val, key) => (
        <option key={key} value={val._id}>
          {val.descripcion}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(ProyectoSelect)
